import * as Yup from "yup"; // Import Yup

// {
//   value : email | phoneNumber
//   password
// }

const loginWithPasswordSchema = Yup.object().shape({
  value: Yup.string().required("Email or Phone Number is required"),
  password: Yup.string().required("Password is required")
});

// {
//   value : email | phoneNumber
// }

const loginWithOTPScheama = Yup.object().shape({
  value: Yup.string().required("Email or Phone Number is required"),
});

export { loginWithPasswordSchema, loginWithOTPScheama };
